import { Routes, Route } from "react-router-dom";
import MainLayout from "./components/layouts/MainLayout";
import NotFound from "./components/NotFound";
import BlogPost from "./components/NewBlogPage/BlogPost";
import SoftSide from "./components/NewCaseStudy/CaseStudies/SoftSide/SoftSide";
import { AuthProvider } from "./context/AuthContext";
import Aes from "./components/NewCaseStudy/CaseStudies/Aes/Aes";
import TanksAndCover from "./components/NewCaseStudy/CaseStudies/tanksandcover/TanksAndCover";
import Ggp from "./components/NewCaseStudy/CaseStudies/ggp/Ggp";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TermAndCondition from "./components/policies/TermAndCondition";
import PrivacyPolicy from "./components/policies/PrivacyPolicy";
import CancellationPolicy from "./components/policies/CancellationPolicy";
import NewHomePage from "./components/NewHomePage/NewHomePage";
import NewAboutPage from "./components/NewAboutPage/NewAboutPage";
import WebsiteAndAppDevelopment from "./components/NewServices/ItService/WebsiteAppDevelopment/WebsiteAndAppDevelopment";
import MobileAndAppDevelopment from "./components/NewServices/ItService/MobileDevelopment/MobileAndAppDevelopment";
import SoftwareAndSaasDevelopment from "./components/NewServices/ItService/SoftwareDevelopment/SoftwareAndSaasDevelopment";
import CloudAndDevopsDevelopment from "./components/NewServices/ItService/CloudAndDevopsDevelopment/CloudAndDevopsDevelopment";
import CyberSecurityProtection from "./components/NewServices/ItService/CyberSecurity/CyberSecurityProtection";
import ItSupportAndMaintenance from "./components/NewServices/ItService/ItSupport/ItSupportAndMaintenance";
import BrandingAndLabel from "./components/NewServices/Designing/BrandingAndLabel/BrandingAndLabel";
import GraphicDesigning from "./components/NewServices/Designing/GraphicDesigning/GraphicDesigning";
import UiUxDesigning from "./components/NewServices/Designing/UiUxDesigning/UiUxDesigning";
import PrintAndMerch from "./components/NewServices/Designing/PrintAndMerch/PrintAndMerch";
import PersonalBranding from "./components/NewServices/BrandingAndMarketing/PersonalBranding/PersonalBranding";
import SeoContentMarketing from "./components/NewServices/BrandingAndMarketing/SeoMarketing/SeoContentMarketing";
import SocialMediaMarketing from "./components/NewServices/BrandingAndMarketing/SocialMediaMarketing/SocialMediaMarketing";
import PayPerClick from "./components/NewServices/BrandingAndMarketing/PayPerClick/PayPerClick";
import EmailMarketing from "./components/NewServices/BrandingAndMarketing/EmailMarketing/EmailMarketing";
import InfluencerMarketing from "./components/NewServices/BrandingAndMarketing/InfluencerMarketing/InfluencerMarketing";
import Analytics from "./components/NewServices/BrandingAndMarketing/Analytics/Analytics";
import WebsiteContent from "./components/NewServices/ContentWriting/WebsiteContent/WebsiteContent";
import SeoBlogWriting from "./components/NewServices/ContentWriting/SeoBlogWriting/SeoBlogWriting";
import AdCopy from "./components/NewServices/ContentWriting/Adcopy/AdCopy";
import SocialMediaContent from "./components/NewServices/ContentWriting/SocialMediaContent/SocialMediaContent";
import PersonalBrandingContent from "./components/NewServices/ContentWriting/PersonalBrandingContent/PersonalBrandingContent";
import PodcastContent from "./components/NewServices/ContentWriting/PodcastContent/PodcastContent";
import AnimatedVideo from "./components/NewServices/VideoEditing/AnimatedVideo/AnimatedVideo";
import SocialMediaVideo from "./components/NewServices/VideoEditing/SocialMediaVideo/SocialMediaVideo";
import YoutubeVideo from "./components/NewServices/VideoEditing/YoutubeVideo/YoutubeVideo";
import CorporateVideo from "./components/NewServices/VideoEditing/CorporateVideo/CorporateVideo";
import PodcastVideo from "./components/NewServices/VideoEditing/PodcastVideo/PodcastVideo";
import TutorialVideo from "./components/NewServices/VideoEditing/TutorialVideo/TutorialVideo";
import NewContactPage from "./components/NewContactPage/NewContactPage";
import NewCaseStudy from "./components/NewCaseStudy/NewCaseStudy";
import NewCareerPage from "./components/NewCareerPage/NewCareerPage";
import NewBlogPage from "./components/NewBlogPage/NewBlogPage";
import NewPortfolio from "./components/NewPortfolio/NewPortfolioPage";

function App() {
  return (
    <>
      <AuthProvider>
        <Routes>
          <Route element={<MainLayout />}>
            <Route path="/" element={<NewHomePage />} />
            <Route path="/who-we-are" element={<NewAboutPage />} />
            <Route path="/case-study" element={<NewCaseStudy />} />
            <Route path="/case-study/softside" element={<SoftSide />} />
            <Route path="/case-study/aes" element={<Aes />} />
            <Route
              path="/case-study/tanksandcover"
              element={<TanksAndCover />}
            />
            <Route path="/case-study/ggp" element={<Ggp />} />
            <Route path="/newportfolio" element={<NewPortfolio />} />

            <Route
              path="/web-app-development"
              element={<WebsiteAndAppDevelopment />}
            />
            <Route
              path="/mobile-app-development"
              element={<MobileAndAppDevelopment />}
            />
            <Route
              path="/software-saas-development"
              element={<SoftwareAndSaasDevelopment />}
            />
            <Route
              path="/cloud-devops-development"
              element={<CloudAndDevopsDevelopment />}
            />
            <Route
              path="/cybersecurity-data-protection"
              element={<CyberSecurityProtection />}
            />
            <Route
              path="/it-support-maintenance"
              element={<ItSupportAndMaintenance />}
            />
            <Route path="/personal-branding" element={<PersonalBranding />} />
            <Route
              path="/seo-content-marketing"
              element={<SeoContentMarketing />}
            />
            <Route
              path="/social-media-marketing"
              element={<SocialMediaMarketing />}
            />
            <Route path="/pay-per-click" element={<PayPerClick />} />
            <Route path="/email-marketing" element={<EmailMarketing />} />
            <Route
              path="/influencer-marketing"
              element={<InfluencerMarketing />}
            />
            <Route
              path="/analytic-and-performance-tracking"
              element={<Analytics />}
            />
            <Route path="/website-content" element={<WebsiteContent />} />
            <Route path="/seo-blog-writing" element={<SeoBlogWriting />} />
            <Route path="/ad-copy-and-sale-funnels" element={<AdCopy />} />
            <Route
              path="/social-media-strategy"
              element={<SocialMediaContent />}
            />
            <Route
              path="/personal-branding-content"
              element={<PersonalBrandingContent />}
            />
            <Route
              path="/podcast-scripting-and-editing"
              element={<PodcastContent />}
            />
            <Route path="/animated-videos" element={<AnimatedVideo />} />
            <Route path="/social-media-videos" element={<SocialMediaVideo />} />
            <Route path="/youtube-video-editing" element={<YoutubeVideo />} />
            <Route
              path="/corporate-and-business-video"
              element={<CorporateVideo />}
            />
            <Route
              path="/podcast-and-interview-editing"
              element={<PodcastVideo />}
            />
            <Route
              path="/explainer-tutorial-video"
              element={<TutorialVideo />}
            />
            <Route path="/branding-and-label" element={<BrandingAndLabel />} />
            <Route path="/graphic-designing" element={<GraphicDesigning />} />
            <Route path="/ui-ux-designing" element={<UiUxDesigning />} />
            <Route path="/print-and-merchandise" element={<PrintAndMerch />} />
            <Route path="/careers" element={<NewCareerPage />} />
            <Route path="/blog" element={<NewBlogPage />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/contact" element={<NewContactPage />} />
            <Route path="/terms-of-services" element={<TermAndCondition />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route
              path="/cancellation-policy"
              element={<CancellationPolicy />}
            />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
        <ToastContainer />
      </AuthProvider>
    </>
  );
}

export default App;
